export default __webpack_public_path__ + "media/Hero_left_desktop.ac2036fb6d76a491134b102a43adb285.svg";